// extracted by mini-css-extract-plugin
module.exports = {"sharer":"share_sharer__NF3Re","webShare":"share_webShare__y3Np7","small":"share_small__y_6k8"};